const translations = {
  // Navbar
  "nav.home": "Ana Sayfa",
  "nav.products": "Ürünler",
  "nav.features": "Özellikler",
  "nav.pricing": "Fiyatlar",
  "nav.orderNow": "Sipariş Ver",
  "nav.contact": "İletişim",
  
  // Hero
  "hero.title": "Her Antrenmanda",
  "hero.titleLine2": "Konfor Deneyimi",
  "hero.subtitle": "Maksimum tutuş, hijyen ve konfor sağlayan premium Pilates ve yoga havluları",
  "hero.orderNow": "Ürünleri gör",
  "hero.discoverMore": "daha fazlasını keşfet",
  
  // Products
  "products.title": "MYSA Ürünleri",
  "products.subtitle": "İyi hissetmek, temiz kalmak ve güvenle tutuş sağlamak için tasarlandı — seveceğiniz renklerde.",
  "products.brown": "Kahverengi",
  "products.crimson": "Bordo Kırmızı",
  "products.earthBrown": "Toprak Kahve",
  "products.multi": "Çoklu",
  "products.pilatesReformerBrown": "Pilates Reformer Seti - Kahverengi",
  "products.pilatesReformerBrownDesc": "Pilates yatağınıza mükemmel uyum sağlayan yenilikçi kaymaz teknolojiye sahip premium set. Üstün tutuş ve hijyen için antibakteriyel materyaller.",
  "products.pilatesReformerCrimson": "Pilates Reformer Seti - Bordo",
  "products.pilatesReformerCrimsonDesc": "Canlı kırmızı, yumuşak ve yüksek emiciliğe sahip pilates havlusu. Sıcak seanslarda kaymaz tutuş için imza silikon teknolojisiyle.",
  "products.yogaTowel": "Yoga Havlusu - Toprak Kahve",
  "products.yogaTowelDesc": "Stili işlevsellikle buluşturan, sıcak toprak tonlarında yoga havlusu. Hijyenik, çabuk kuruyan ve çevre dostu tasarımıyla öne çıkar.",
  "products.completeSet": "Pilates Reformer Seti",
  "products.completeSetDesc": "Antrenmanınız için ihtiyacınız olan her şey tek bir sette. Pilates Reformer matı, favori renginizde yoga havlusu, hafif yüz havlusu ve spor çantasından oluşur. Kendini pratiğine adamış olanlar için ideal.",
  
  // Features
  "features.title": "Neden MYSA'yı Seçmelisiniz",
  "features.subtitle": "Her detay özenle tasarlandı. Ürünlerimizi wellness yolculuğunuz için mükemmel bir yol arkadaşı yapan özellikleri keşfedin.",
  "features.hygiene": "Üstün Hijyen",
  "features.hygieneDesc": "Ürünlerimiz hijyeni ön planda tutarak tasarlandı. Temizlemesi kolay, çabuk kuruyan, bakteri ve kokuya dirençli malzemeler, antrenmanınızı taze ve sağlıklı tutar.",
  "features.antiSlip": "Yenilikçi Kaymaz Teknoloji",
  "features.antiSlipDesc": "Pilates yatağınıza mükemmel yapışan benzersiz yapışkan nokta deseni. Kayma yok, kaydırma yok—sadece tam stabilite ve güvenle antrenmanınıza odaklanın.",
  "features.eco": "Çevre Dostu Malzemeler",
  "features.ecoDesc": "Sürdürülebilir kaynaklı, gezegene dost çevre dostu malzemeler. Sağlığın kişisel sağlığın ötesinde Dünyamızın sağlığına uzandığına inanıyoruz.",
  "features.colors": "Canlı Renkler",
  "features.colorsDesc": "Neşe ve enerji veren güzel, zengin renkler. Derin bordo kırmızılardan sıcak toprak kahverengilerine, ürünlerimiz antrenman alanınıza hayat ve kişilik katar.",
  "features.comfort": "Üstün Konfor",
  "features.comfortDesc": "MYSA rahatlık demek ve bu sözü tutuyoruz. Vücudunuzu desteklerken mükemmel tutuş ve konfor dengesi sağlayan yumuşak, yastıklı malzemeler.",
  "features.quality": "Premium Kalite",
  "features.qualityDesc": "Sayısız seans boyunca dayanacak şekilde üretildi. Yüksek kaliteli yapı ve malzemeler, yatırımınızın yıllarca güzel performans göstermesini sağlar.",
  "features.techTitle": "Tutuşun Arkasındaki Teknoloji",
  "features.techDesc": "Silikon durdurma teknolojimiz sadece tutuşla ilgili değil—antrenmanınızda kendinizi topraklanmış hissetmenize yardımcı olmakla ilgili. Her nokta, cildinizde yumuşak ve rahat hissettirirken Pilates yataklarına güvenli bir şekilde yapışacak şekilde özenle tasarlandı. Sonuç? Düşünmenize gerek kalmayan, yerinde duran bir mat. Kayma yok, sürekli ayarlama yok—sadece pürüzsüz hareket, sabit nefes ve dikkat dağıtmayan bir akış.",
  
  // Pricing
  "pricing.label": "Bilinçli Yatırım",
  "pricing.title": "Pratik Ürünlerinizi Seçin",
  "pricing.subtitle": "Sağlık yolculuğunuz için özenle hazırlanmış kaliteli ürünler",
  "pricing.yogaTowel": "Yoga Havlusu",
  "pricing.pilatesSet": "Pilates Reformer Seti",
  "pricing.wellnessSet": "Komple Wellness Seti",
  "pricing.favorite": "Favorimiz",
  "pricing.select": "Seç",
  "pricing.freeShipping": "Ücretsiz Kargo",
  "pricing.freeShippingDesc": "1000₺ üzeri siparişler",
  "pricing.ecoFriendly": "Çevre Dostu",
  "pricing.ecoFriendlyDesc": "Sürdürülebilir malzemeler",
  "pricing.madeWithCare": "Özenle Üretildi",
  "pricing.madeWithCareDesc": "30 gün garanti",
  "pricing.saveBundle": "200TL Tasarruf",
  "pricing.feature1": "Premium mikrofiber malzeme",
  "pricing.feature2": "Akıllı silikon tutunma noktaları",
  "pricing.feature3": "Hızlı kuruma teknolojisi",
  "pricing.feature4": "Makinede yıkanabilir",
  "pricing.feature5": "Çoklu renk seçenekleri",
  "pricing.setFeature1": "Tam reformer kaplama",
  "pricing.setFeature2": "Kaymaz silikon taban",
  "pricing.setFeature3": "Nem emici kumaş",
  "pricing.setFeature4": "Kahverengi ve Kırmızı renklerde",
  "pricing.setFeature5": "Profesyonel kalite",
  "pricing.wellnessFeature1": "1 Pilates Reformer Seti",
  "pricing.wellnessFeature2": "1 Yoga Havlusu (renk seçiminize göre)",
  "pricing.wellnessFeature3": "1 Yüz havlusu dahil",
  "pricing.wellnessFeature4": "Premium spor çantası",
  "pricing.wellnessFeature5": "Sette ₺200 tasarruf",
  "pricing.buyOnTrendyol": "Trendyol'da Satın Al",
  
  // CTA
  "cta.title": "Antrenmanınızı",
  "cta.titleLine2": "Dönüştürmeye Hazır mısınız?",
  "cta.subtitle": "MYSA ürünleriyle konfor, performans ve sürdürülebilirliğin mükemmel karışımını keşfeden binlerce pratisyene katılın.",
  "cta.button": "Yolculuğunuza Bugün Başlayın",
  "cta.practitioners": "Mutlu Pratisyen",
  "cta.ecoFriendly": "Çevre Dostu",
  "cta.rating": "Ortalama Puan",
  
  // Order Form
  "order.title": "Siparişinizi Verin",
  "order.subtitle": "Aşağıdaki formu doldurun, siparişinizi onaylamak için en kısa sürede sizinle iletişime geçeceğiz.",
  "order.fullName": "Ad Soyad",
  "order.email": "E-posta Adresi",
  "order.phone": "Telefon Numarası",
  "order.selectProduct": "Ürün Seçin",
  "order.clickToSelect": "Seçmek için bir ürüne tıklayın",
  "order.quantity": "Adet",
  "order.colorPreference": "Renk Tercihi",
  "order.selectColor": "Renk seçin",
  "order.crimsonRed": "Bordo Kırmızı",
  "order.earthBrown": "Toprak Kahve",
  "order.noPreference": "Tercih Yok",
  "order.streetAddress": "Adres",
  "order.city": "Şehir",
  "order.state": "İlçe",
  "order.zipCode": "Posta Kodu",
  "order.additionalNotes": "Ek Notlar",
  "order.notesPlaceholder": "Özel istek veya sorularınız var mı? (Maks 500 karakter)",
  "order.characters": "karakter",
  "order.success": "Sipariş Başarıyla Gönderildi!",
  "order.successDesc": "Siparişinizi onaylamak için en kısa sürede sizinle iletişime geçeceğiz.",
  "order.error": "Gönderim Başarısız",
  "order.errorDesc": "Lütfen tekrar deneyin veya doğrudan bizimle iletişime geçin.",
  "order.submit": "Sipariş Ver",
  "order.submitting": "Gönderiliyor...",
  "order.terms": "Bu formu göndererek şartlar ve koşullarımızı kabul etmiş olursunuz. Siparişinizi onaylamak ve ödemeyi ayarlamak için sizinle iletişime geçeceğiz.",
  "order.required": "Lütfen tüm zorunlu alanları doldurun",
  
  // Footer
  "footer.description": "Wellness yolculuğunuz için özenle tasarlanmış premium Pilates ve Yoga ürünleri. Çevre dostu, canlı ve dayanıklı.",
  "footer.quickLinks": "Hızlı Bağlantılar",
  "footer.contact": "İletişim",
  "footer.followUs": "Bizi Takip Edin",
  "footer.community": "Topluluğumuza katılın ve wellness ipuçları ve özel tekliflerden haberdar olun.",
  "footer.rights": "© 2024 MYSA. Tüm hakları saklıdır.",
  "footer.privacy": "Gizlilik Politikası",
  "footer.terms": "Kullanım Şartları",
  "footer.alsoAvailable": "Ayrıca mevcut",
  "footer.shopTrendyol": "Trendyol\u0027da Alışveriş Yap",

  // Contact
  "contact.label": "İletişime Geçin",
  "contact.title": "Size Yardımcı Olmak İçin Buradayız",
  "contact.subtitle": "Ürünlerimiz, siparişiniz hakkında bir sorunuz mu var veya sadece merhaba demek mi istiyorsunuz? Sizden haber almak isteriz.",
  "contact.emailUs": "E-posta Gönderin",
  "contact.emailResponse": "24 saat içinde yanıt veriyoruz",
  "contact.callUs": "Bizi Arayın",
  "contact.callHours": "Pzt\u2013Cum, 09:00\u201318:00",
  "contact.whatsapp": "WhatsApp",
  "contact.whatsappChat": "Sohbet başlatın",
  "contact.whatsappResponse": "Bize ulaşmanın en hızlı yolu",
  "contact.location": "Konum",
  "contact.followUs": "Bizi Takip Edin",
  "contact.formTitle": "Bize Mesaj Gönderin",
  "contact.formSubtitle": "Genellikle birkaç saat içinde yanıt veriyoruz",
  "contact.nameLabel": "Ad Soyad",
  "contact.namePlaceholder": "Adınız",
  "contact.emailLabel": "E-posta Adresi",
  "contact.emailPlaceholder": "siz@ornek.com",
  "contact.subjectLabel": "Nasıl yardımcı olabiliriz?",
  "contact.subjectPlaceholder": "Bir konu seçin",
  "contact.subjectProduct": "Ürün Soruları",
  "contact.subjectOrder": "Sipariş Desteği",
  "contact.subjectShipping": "Kargo ve Teslimat",
  "contact.subjectReturns": "İade ve Değişim",
  "contact.subjectOther": "Diğer",
  "contact.messageLabel": "Mesajınız",
  "contact.messagePlaceholder": "Size nasıl yardımcı olabileceğimizi anlatın...",
  "contact.sendButton": "Mesaj Gönder",
  "contact.sending": "Gönderiliyor...",
  "contact.privacy": "Bilgileriniz güvende ve gizlidir",
  "contact.successTitle": "Mesaj Gönderildi!",
  "contact.successDesc": "En kısa sürede size geri döneceğiz.",
  "contact.errorTitle": "Bir şeyler ters gitti",
  "contact.errorDesc": "Lütfen tekrar deneyin veya doğrudan bize e-posta gönderin.",

  // Gallery
  "gallery.label": "Galeri",
  "gallery.title": "MYSA\u0027yı Antrenmanınızda Görün",
  "gallery.subtitle": "Topluluğumuzdan gerçek anlar - MYSA ürünlerinin her seansı nasıl geliştirdiğini görün.",
  "gallery.filterAll": "Tümü",
  "gallery.filterProducts": "Ürünler",
  "gallery.filterPractice": "Pratikte",
  "gallery.filterDetails": "Yakından",
  "gallery.image1Alt": "MYSA pilates reformer havlusu toprak kahve rengi reformer makinesinde",
  "gallery.image1Caption": "Premium tutuş ve zarif tasarım her reformerde",
  "gallery.image2Alt": "Silikon kaymaz tutuş noktaları yakın çekim",
  "gallery.image2Caption": "Eşsiz stabilite için yenilikçi silikon teknolojisi",
  "gallery.image3Alt": "MYSA havlusu ile pilates pratiği",
  "gallery.image3Caption": "Her seansta sabit akış ve tam odaklanma",
  "gallery.image4Alt": "Komple MYSA wellness seti düz çekim",
  "gallery.image4Caption": "İhtiyacınız olan her şey — havlu, mat, çanta, hepsi bir sette",
  "gallery.image5Alt": "MYSA havlusu ile yoga seansı",
  "gallery.image5Caption": "Her pozda konfor ve huzur",
  "gallery.image6Alt": "MYSA yoga havlusu aksesuarlarla birlikte",
  "gallery.image6Caption": "Bir sonraki seansınız için hazır, nereye giderseniz gidin",
  "gallery.image7Alt": "Pilates reformerde tutuş detayı",
  "gallery.image7Caption": "Sizi topraklanmış tutan kaymaz noktalar",
  "gallery.image8Alt": "MYSA havlularıyla modern pilates stüdyosu",
  "gallery.image8Caption": "Premium hijyen ve konfor için stüdyoların tercihi",
  "gallery.image9Alt": "MYSA bordo havlusu ile çocuk pozunda yoga pratiği",
  "gallery.image9Caption": "Her yüzeyde derin esneme ve tam konfor",
  "gallery.followInstagram": "Instagram\u0027da Bizi Takip Edin"
};

export default translations;
